import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import ForwardArrowIcon from '../assets/icons/arrow_forward_24.svg'

const BreadcrumbInHeader = ({ category, currentPage, storeType }) => {
  const storeLink = storeType === 'McColls' ? `/mccolls` : '/'

  return (
    <div className="flex flex-wrap items-center mb-4 text-sm leading-none text-white lg:mb-8">
      <Link
        to={storeLink}
        className="inline-block text-white hover:underline whitespace-nowrap"
      >
        Store Finder Home
      </Link>
      <ForwardArrowIcon className="inline-block w-2 h-2 mx-2 fill-current" />
      {currentPage && (
        <>
          <span className="hidden text-white sm:inline-block">
            {currentPage}
          </span>
        </>
      )}
    </div>
  )
}

BreadcrumbInHeader.propTypes = {
  category: PropTypes.string,
  currentPage: PropTypes.string,
  storeType: PropTypes.string,
}

export default BreadcrumbInHeader
